<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <el-select v-model="query.siteIds[0]" size="small" @change="onSearchBtnClick">
      <el-option
        v-for="site in filterSites"
        :key="site.id"
        :value="site.id"
        :label="site.name"
      />
    </el-select>

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <!-- <el-checkbox v-model="query.isMultipleIntegral" size="small" label="重积分" border v-if="query.isAuditCompleted !== false" /> -->

    <el-button
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <unit-switch :default-unit-prop.sync="unitProp" />
      </template>

<!--      <chart-group-->
<!--        v-for="data in dataList"-->
<!--        :key="data.id"-->
<!--        :data-config="data"-->
<!--        :unit-prop="unitProp"-->
<!--        :chart-type="chartType"-->
<!--        :stack-type="stackType"-->
<!--        :download-name="downloadName"-->
<!--        :aggregation-factor-groups="aggregationFactorGroups"-->
<!--        :site="currentSite"-->
<!--      />-->
      <chart-group
        v-for="(factorChartGroup, index) in factorChartGroups"
        :key="`${currentSite.id}-${index}`"
        ref="chart-groups"
        :site="currentSite"
        :default-factor-ids="factorChartGroup"
        :unit-prop="unitProp"
        :query="currentQuery"
        :site-factor-map="siteFactorMap"
        :factor-site-map="factorSiteMap"
        :complete-all-data="completeAllData"
        :filter-site-map="filterSiteMap"
        :dimension="dimension"
        @rendered="onChartRendered"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseSiteFactorData from '../../../BaseSiteFactorData'

import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import UnitSwitch from '../../../../components/Data/UnitSwitch'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'
import ChartGroup from './ChartGroup'

export default {
  name: 'VOCsComplexAnalysis',
  routeInfo: {
    label: '综合分析',
    icon: 'fa fa-users'
  },
  extends: BaseSiteFactorData,
  components: {
    ChartGroup,
    UnitSwitch,
    DataWrapper,
    DataTimeQuery,
    LayoutContent
  },
  data: () => ({
    query: {
      isFuse: false,
      isMultipleIntegral: true
    },
    chartType: 'line',
    stackType: 1,
    count: 0
  }),
  computed: {
    siteDeviceCategoryConfig () {
      // return [
      //   new DeviceCategoryConfig(process.env.METEOROLOGICAL_DEVICE_CATEGORY, false),
      //   new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
      //   new DeviceCategoryConfig(process.env.ULTRAVIOLET_DEVICE_CATEGORY, false),
      //   new DeviceCategoryConfig(process.env.JNO2_DEVICE_CATEGORY, false),
      //   new DeviceCategoryConfig(process.env.PAN_DEVICE_CATEGORY, false),
      //   new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
      //   new DeviceCategoryConfig(process.env.NOY_DEVICE_CATEGORY, false),
      //   new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, false),
      //   new DeviceCategoryConfig(process.env.HCHO_DEVICE_CATEGORY, false),
      //   new DeviceCategoryConfig(process.env.NMHC_DEVICE_CATEGORY, false)
      // ]
      return [
        new DeviceCategoryConfig(1, true),
        new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.METEOROLOGICAL_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.VOCS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NMHC_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.HCHO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PAN_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.OCEC_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.HEAVY_METAL_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.SPAMS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.BLACK_CARBON_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.LIGHT_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ORGANIC_SULFUR_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.GONG_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PARTICLE_SIZE_SPECTRUM_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO2_DIRECT_DETECTION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NOY_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO2_DIRECT_DETECTION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NOY_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.SUN_RADIATION_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.GREENHOUSE_GAS_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.ULTRAVIOLET_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PHOTOLYSIS_RATE_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NEGATIVE_OXYGEN_ION_DEVICE_CATEGORY, false)
      ]
    },
    isSetAllFactorIds: () => 0,
    aggregationFactorGroups () {
      return this.factorGroups.filter(factorGroup => factorGroup.parentId === 'm30000')
    },
    downloadName: () => 'VOCs结合分析',
    currentSite () {
      const [siteId] = this.query.siteIds
      return this.filterSites.find(site => site.id === siteId)
    },
    factorChartGroups () {
      const {currentSite} = this

      if (currentSite) {
        const groups = [
          // 温度、湿度、降水量
          ['1010', '1011', '8000'],
          // 紫外辐射、// JNO2
          ['1018', '4006'],
          // O3、PAN
          ['1006', '6001'],
          // NO、NO2、NOY
          ['1002', '1003', '6203'],
          // VOCs分类、非甲烷总烃、甲醛
          this.aggregationFactorGroups.map(factorGroup => factorGroup.id).concat(['1026', '2411'])
        ]
        const groupMap = groups.reduce((map, ids, index) => ids.reduce((map, id) => {
          let group = map[id]

          if (!group) {
            group = map[id] = []
          }

          group.push(index)

          return map
        }, map), {})

        return Object.values(Object.values(this.siteFactorMap[currentSite.id].map).reduce((map, factor) => {
          const {factorId} = factor
          const groupInfos = groupMap[factorId] || groupMap[factor.parentId]

          if (groupInfos) {
            groupInfos.forEach(groupIndex => {
              let groups = map[groupIndex]

              if (!groups) {
                groups = map[groupIndex] = []
              }

              groups.push(factorId)
            })
          }

          return map
        }, {}))
      }

      return []
    }
  },
  methods: {
    // onUnitPropChange () {
    //
    // }
    // getSeriesParam (dimension, dimensionIds) {
    //   let factorId = dimensionIds[dimension ^ 1]
    //   let param = {
    //     type: 'line',
    //     showSymbol: false
    //   }
    //
    //   if (/^(100(2|3|4))$/.test(factorId)) {
    //     param.areaStyle = {}
    //   }
    //
    //   return param
    // },
    // setDataList (dataList) {
    //   this.tmpList = Object.freeze(DataFormatter.formatWeatherDataList.bind(this)(dataList))
    //   this.formatData()
    // }
    afterSetSiteIds () {
      this.setCurrentQuery()
    },
    onChartRendered () {
      this.count++

      if (this.factorChartGroups.length === this.count && this.count > 0) {
        this.$refs['chart-groups'][0].getChartComponent().connect(this.$refs['chart-groups'].map(component => component.getChartComponent()))
        this.count = 0
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/01Photochemical/06ComplexAnalysis/index.vue